import React, { useState } from 'react'
import './About.css'
import { useDocumentMeta } from '../seo/useDocumentMeta'

function About() {
  useDocumentMeta()
  const [expandedSections, setExpandedSections] = useState({
    whoWeAre: false,
    whatMatters: false,
    adultNotice: false,
    productNotice: false,
    contact: false
  })

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }))
  }

  return (
    <div className="about-page">
      <div className="about-content">
        <section className="about-section collapsible-section">
          <button 
            className="section-header" 
            onClick={() => toggleSection('whoWeAre')}
          >
            <h2>Who We Are</h2>
            <span className="toggle-icon">{expandedSections.whoWeAre ? '−' : '+'}</span>
          </button>
          {expandedSections.whoWeAre && (
            <div className="section-content">
              <p>
                Plur is an intimate wellness brand focused on thoughtful design, comfort, and discretion.
              </p>
              <p>
                We believe intimacy is deeply personal. It doesn't need to be loud, explicit, or explained. 
                It should feel natural, safe, and intentional.
              </p>
              <p>
                Every product at Plur is curated with care — from refined lingerie to personal wellness devices — 
                selected to support confidence, connection, and self-awareness, whether experienced alone or shared.
              </p>
            </div>
          )}
        </section>

        <section className="about-section collapsible-section">
          <button 
            className="section-header" 
            onClick={() => toggleSection('whatMatters')}
          >
            <h2>What Matters to Us</h2>
            <span className="toggle-icon">{expandedSections.whatMatters ? '−' : '+'}</span>
          </button>
          {expandedSections.whatMatters && (
            <div className="section-content">
          <div className="values-list">
            <div className="value-item">
                  <h3>Discretion & Privacy</h3>
                  <p>Your privacy is fundamental. All orders are shipped discreetly, and customer data is handled with care and respect.</p>
            </div>
            <div className="value-item">
              <h3>Quality & Safety</h3>
                  <p>We prioritize body-safe materials, reliable manufacturing standards, and products designed for real comfort and long-term use.</p>
            </div>
            <div className="value-item">
                  <h3>Thoughtful Curation</h3>
                  <p>We don't aim to offer everything — only what we believe is worth offering.</p>
                </div>
              </div>
            </div>
          )}
        </section>

        <section className="about-section collapsible-section">
          <button 
            className="section-header" 
            onClick={() => toggleSection('adultNotice')}
          >
            <h2>Adult Use Notice</h2>
            <span className="toggle-icon">{expandedSections.adultNotice ? '−' : '+'}</span>
          </button>
          {expandedSections.adultNotice && (
            <div className="section-content">
              <p>
                Plur is intended for adults only.
              </p>
              <p>
                By accessing this website, you confirm that you are 18 years of age or older and legally permitted 
                to view and purchase adult products in your location.
              </p>
              <p>
                All imagery and representations on this website depict adults aged 18 or above.
              </p>
            </div>
          )}
        </section>

        <section className="about-section collapsible-section">
          <button 
            className="section-header" 
            onClick={() => toggleSection('productNotice')}
          >
            <h2>Product Notice</h2>
            <span className="toggle-icon">{expandedSections.productNotice ? '−' : '+'}</span>
          </button>
          {expandedSections.productNotice && (
            <div className="section-content">
              <p>
                Due to the personal nature of intimate products, all sales are final unless an item arrives defective or damaged.
              </p>
              <p>
                If you experience a quality-related issue, our support team is available to assist.
              </p>
          </div>
          )}
        </section>

        <section className="about-section collapsible-section">
          <button 
            className="section-header" 
            onClick={() => toggleSection('contact')}
          >
            <h2>Contact</h2>
            <span className="toggle-icon">{expandedSections.contact ? '−' : '+'}</span>
          </button>
          {expandedSections.contact && (
            <div className="section-content">
              <p>
                For questions regarding products or orders, please contact us at:
          </p>
              <p className="contact-email">
                <a href="mailto:support@p1ur.com">support@p1ur.com</a>
              </p>
          </div>
          )}
        </section>
      </div>
    </div>
  )
}

export default About
